export default __webpack_public_path__ + "static/media/Q4_1_resized.a5594262.jpg";